const formItems = [
  { label: '模板名称', model: 'name', type: 'input', span: 6 },
  {
    type: 'button',
    buttonArr: [
      { message: '查询', type: 'primary', fun: 'searchTableInfo' },
      { message: '重置', type: 'warning', fun: 'resetTableInfo' }
    ],
    span: 12
  }
];
const getColumnsMap = ({ editDraft, delDraft }) => {
  return {
    title: {
      title: '标题',
      key: 'title',
      minWidth: 120
    },
    applyNo: {
      title: '模板编号',
      key: 'applyNo',
      minWidth: 120
    },
    addTime: {
      title: '创建时间',
      key: 'addTime',
      minWidth: 120
    },
    name: {
      title: '模板组',
      key: 'name',
      minWidth: 120
    },
    action: {
      title: '操作',
      align: 'left',
      key: 'action',
      minWidth: 100,
      fixed: 'right',
      render: (h, { row }) => {
        const { id } = row;
        const buttonArr = [];
        buttonArr.push(
          h('CustomButton', {
            props: { type: 'success', size: 'small' },
            style: { margin: '4px' },
            on: {
              click: () => {
                editDraft(id);
              }
            }
          }, '编辑')
        );
        buttonArr.push(
          h('CustomButton', {
            props: { type: 'success', size: 'small' },
            style: { margin: '4px' },
            on: {
              click: () => {
                delDraft(id);
              }
            }
          }, '删除')
        );
        return h('div', { style: { 'text-align': 'left' } }, buttonArr);
      }
    }
  };
};
const getColumns = (methods, noShowArr) => {
  const columnsMap = getColumnsMap(methods);
  const keyArr = Object.keys(columnsMap);
  const columns = [];
  keyArr.forEach(key => {
    if (!noShowArr || !noShowArr.includes(key)) {
      columns.push(columnsMap[key]);
    }
  });
  return columns;
};
export { formItems, getColumns };
